<template>
  <section class="cool-modal" :class="modal.class || ''" @click="clickParent">
    <transition name="modal">
      <div class="mask" v-if="animationShow">
        <div class="modal-wrap" @click.stop>
          <i class="iconfont etc-icon-close" v-if="modal.close" @click="hide()"></i>
          <div class="modal-header" v-if="modal.header" @click.stop="clickHeader">
            {{modal.header.text || modal.header}}
          </div>
          <slot name="content" v-if="modal.contentSlot"></slot>
          <ul class="modal-content" v-if="!modal.contentSlot && modal.content">
            <li class="modal-content-li" v-for="(item, index) in modal.content" :key="index" @click.stop="clickItem(item)">
              {{item.text}}
            </li>
          </ul>
          <div class="modal-footer" v-if="modal.footer || modal.defaultFooter" @click.stop="clickFooter">
            {{modal.footer.text || modal.footer || '取消'}}
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>

const MODAL = {
  class: '',
  header: '',
  content: '',
  footer: '',
  defaultFooter: true,
  parentHide: false,
  contentSlot: false
}
export default {
  name: 'modal',
  components: {},
  data() {
    return {
      animationShow: false,
      modal: {
        class: '',
        header: '',
        content: '',
        footer: '',
        defaultFooter: true,
        parentHide: false,
        contentSlot: false
      }
    }
  },
  computed: {},
  methods: {
    clickItem(item) {
      if (item.handle) item.handle()
    },
    clickParent() {
      if (this.modal.parentHide) {
        this.hide()
      }
    },
    clickHeader() {},
    clickFooter() {
      if (this.modal.footer.handler) {
        this.modal.footer.handler()
      }
      this.hide()
    },
    hide() {
      this.animationShow = false
      this.$emit('modalHide')
    }
  },
  mounted() {
    this.$on('showModal', data => {
      if (this.animationShow) return
      this.modal = Object.assign({}, MODAL, data)
      this.animationShow = true
    })
    this.$on('hideModal', data => {
      this.hide()
    })
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.cool-modal{
  .mask {
    @extend %all-mask;
  }
  .modal-wrap{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    .etc-icon-close{
      position: absolute;
      top: 15px;
      right: 15px;
      color: #999999;
      font-size: 30px;
      z-index: 102;
      padding: 15px;
    }
    .modal-content-li{
      background-color: #FFFFFF;
      height: 90px;
      border-bottom: 1px solid $border-bottom-color;
      @extend %flex-center;
      &:last-child{
        border-bottom: none;
      }
    }
    .modal-footer{
      margin-top: 5px;
      background-color: #FFFFFF;
      text-align: center;
      height: 90px;
      line-height: 90px;
    }
  }
  .modal-enter-active, .modal-leave-active {
    transition: opacity .3s;
    .modal-wrap{
      transition: transform .4s;
    }
  }
  .modal-enter{
    opacity: 0;
    .modal-wrap{
      transform: translateY(100%);
    }
  }
  .modal-enter-to{
    opacity: 1;
    .modal-wrap{
      transform: translateY(0);
    }
  }
  .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    .modal-wrap{
      transform: translateY(100%);
    }
  }
}
</style>
